"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMenuMobile = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helperFunctions = require("../../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledMenuMobile = _styledComponents.default.div.withConfig({
  displayName: "AuthorizedMenuMobilestyles__StyledMenuMobile",
  componentId: "arzt1l-0"
})(["display:none;position:relative;@supports (display:grid){&{display:grid;grid-template-areas:\"mobileMenuTop\" \"mobileMenu\";grid-template-rows:min-content 1fr;grid-template-columns:1fr;height:auto;left:0;top:0;width:100%;z-index:", ";}.c-menu-mobile{align-items:stretch;display:grid;flex-direction:column;grid-area:mobileMenuTop;grid-template-columns:min-content 1fr min-content;grid-template-areas:\"mobileLogo mobileTitle mobileItem\";height:", ";justify-content:center;justify-items:flex-start;width:100%;z-index:", ";}.c-menu-mobile-menu-items-wrapper{grid-area:mobileMenu;width:100%;}.c-menu-mobile-logo-wrapper{align-items:center;display:flex;grid-area:mobileLogo;padding-left:", ";}.c-menu-mobile-title{grid-area:mobileTitle;align-items:center;display:flex;justify-self:center;padding-right:", ";}.c-title-text{font-weight:", ";}.c-menu-mobile-user-button{grid-area:mobileItem;border:none;cursor:pointer;display:flex;outline:none;padding-right:", ";text-align:center;align-items:center;}@media only screen and (min-width:", "){display:none;}}"], function (props) {
  return props.theme.menu;
}, function (props) {
  return props.theme.mobileMenuHeight;
}, function (props) {
  return props.theme.menu;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', '2', props.theme.standardPadding);
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', '2', props.theme.standardPadding);
}, function (props) {
  return props.theme.primaryMedium;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', '2', props.theme.standardPadding);
}, function (props) {
  return props.theme.maxWidth;
});

exports.StyledMenuMobile = StyledMenuMobile;